import { useCallback } from "react";
import { useMutation, useQuery } from "urql";
import { graphql } from "@acto/gql";

const CurrentUserPreferencesQuery = graphql(`
  query GetCurrentUserPreferences {
    currentUserPreferences {
      id
      __typename
      locale
    }
  }
`);

const UpdateCurrentUserPreferencesMutation = graphql(`
  mutation UpdateCurrentUserPreferences($input: UpdateUserPreferencesInput!) {
    updateCurrentUserPreferences(input: $input) {
      id
      __typename
      locale
    }
  }
`);

export function useUserLocale() {
  const [result] = useQuery({ query: CurrentUserPreferencesQuery });
  const [, mutate] = useMutation(UpdateCurrentUserPreferencesMutation);

  const saveLocale = useCallback(
    async (locale: string) => {
      const response = await mutate({ input: { locale } });
      if (response.error || response.data?.updateCurrentUserPreferences.locale !== locale) {
        throw response.error ?? new Error("Language preference was not saved");
      }
    },
    [mutate],
  );

  return { locale: result.data?.currentUserPreferences.locale, fetching: result.fetching, saveLocale };
}
